<template>
    <div class>
      <v-toolbar dark :color="this.$gf.headerColor()">
        <v-toolbar-title>
          <v-icon class="icon">fa-users</v-icon>Copy Notification Settings
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <!--<v-toolbar dark color="secondary">
        <v-chip color text-color="white" @click="e1 = 1">
          <v-avatar>
            <v-icon x-small>fa-user</v-icon>
          </v-avatar>
          {{ selectedCustomerCount }} Selected Customers
        </v-chip>
      </v-toolbar>-->
      <div id="slideout-container" class="scroll-y">
        <v-stepper v-model="e1" class="no-transition">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">Select Customers</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="max-height-list scroll-y">
              <h4 v-if="allCustomersEnrolled">Notification copied to the all customers.</h4>
            <v-skeleton-loader v-if="customerLoading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
            <v-skeleton-loader v-if="customerLoading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
              <v-data-table
                v-model="selectedUsers"
                v-if="!allCustomersEnrolled"
                v-show="!customerLoading"
                :headers="customerHeaders"
                :options.sync="customerOptions"
                :server-items-length="serverCustomerItemsLength"
                :items="customers"
                item-key="id"
                show-select
                :footer-props="{
                  'items-per-page-options': [5,10,15,-1]
                  }"
              ></v-data-table>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
      <v-footer absolute height="68">
        <v-flex px-4 py-4 text-right>
          <div v-if="e1 == 1">
            <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
            <v-btn color="primary" @click="copyNotifications">Copy Settings</v-btn>
          </div>
        </v-flex>
      </v-footer>
    </div>
  </template>
  <script>
  import { EventBus } from "@/event-bus.js";
  import partnerAPI from "@/api/partner.js";
  export default {
    name: "UserDetails",
    props: {
      id: {
        type: String,
        default: null
      },
      params: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        customerHeaders: [
          { text: "Company Name", value: "company_name" }
        ],
        loading: false,
        e1: 1,
        selectedUsers: [],
        customerSearch: "",
        customers: [],
        customerSearchParams: "",
        customerOptions: {},
        customerLoading: false,
        customerPagination: {},
        successMessage: "Notification copied successfully.",
        errorMessage: "Oops, something went wrong!",
        nothingSelected: "You haven't selected any Customers.",
        allCustomersEnrolled: false,
        confirmCopy: "Are you sure you want to copy your settings?",
      };
    },
    computed: {
      serverCustomerItemsLength: function() {
        return this.customerPagination.total;
      },
      customerParams: function() {
        return this.$gf.getQueryString(this.customerOptions, this.serverCustomerItemsLength);
      },
      isTabletOrDesktop() {
        const width = this.$vuetify.breakpoint.width;
        return width >= 820;
      },
    },
    watch: {
      customerOptions: {
        handler() {
          this.getCustomers();
        },
        deep: true
      }
    },
    mounted() {
      this.setEventBus();
    },
    methods: {
      getCustomers() {
        this.customerLoading = true;
        partnerAPI
          .getOwners(
            this.customerParams,
            this.customerSearchParams,
            this.$store.getters.user.id+'&include=company&demo=yes'
          )
          .then(resp => {
            this.customers = resp.data.data;
            this.customerPagination = resp.data.meta.pagination;
            this.customerLoading = false;
            this.customers.length == 0
              ? (this.allCustomersEnrolled = true)
              : (this.allCustomersEnrolled = false);
          });
      },
      processSelectedUsers() {
        let users = [];
        this.selectedUsers.forEach(function(x) {
          users.push(x.id);
        });
        return users;
      },
      process() {
        this.loading = true;
        partnerAPI
          .copyNotification(this.processSelectedUsers())
          .then(() => {
            EventBus.$emit("COURSES_UPDATED", this.params);
            this.closePanel();
            this.$snotify.success(this.successMessage);
            this.loading = false;
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          })
          .catch(() => {
            this.$snotify.error(this.errorMessage);
            this.loading = false;
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          });
      },
      copyNotifications() {
        this.$snotify.confirm(this.confirmCopy, {
          backdrop:0.3,                         
          buttons: [
            { text: "Cancel",className: 'toast-cancel-button' },
            {
              text: "Yes",className: 'toast-continue-button',
              action: toast => this.processcopyNotifications(toast)
            }            
          ]
        });
      },
      processcopyNotifications(toast) {
        this.$snotify.remove(toast.id);
        if (this.selectedCustomerCount === 0) {
          this.$snotify.error(this.nothingSelected);
        } else {
          this.process();
        }
      },
      setEventBus() {
        EventBus.$on("DATE_SELECTED", date => {
          this.deadlineSet = true;
          this.selectedDate = date;
        });
      },
      closePanel() {
        this.$emit("closePanel", {});
      }
    }
  };
  </script>
  <style media="screen">
  #slideout-container {
    height: calc(100vh - 65px - 100px);
  }
  .max-height-list {
    height: calc(100vh - 65px - 100px - 48px);
  }
  .no-transition .stepper__content {
    transition: none;
  }
  </style>
  